import { lazy, Suspense, useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";
import GenericFlyout from "../modal/GenericFlyout";
import { useBjelinTranslations } from "../../hooks/TranslationHooks";
import Icon from "../Icon";
import "./search-dropdown.scss";
import { Spinner } from "reactstrap";
import { useOverlayContext } from "../../functional-components/OverlayContext";

const SearchContent = lazy(() =>
  import("../../pages/SearchPage").then(module => ({
    default: module.SearchContent
  }))
);

const SearchDropdown = () => {
  const location = useLocation();
  const t = useBjelinTranslations();
  const { searchOpened, setSearchOpened } = useOverlayContext();
  const closeSearchDropdown = useCallback(
    () => setSearchOpened(false),
    [setSearchOpened]
  );
  const toggleSearchDropdown = useCallback(
    () => setSearchOpened(!searchOpened),
    [searchOpened, setSearchOpened]
  );
  useEffect(() => {
    if (location.key) {
      setSearchOpened(false);
    }
  }, [setSearchOpened, location.key]);
  return (
    <>
      <button
        id="search-menu-button"
        title={t("menu.tooltip.search")}
        aria-haspopup="dialog"
        className="nav-link"
        style={{
          backgroundColor: searchOpened ? "#fff" : "transparent",
          border: 0
        }}
        aria-expanded={searchOpened}
        onClick={toggleSearchDropdown}
      >
        <Icon name="magnifying-glass" className="icon" />
      </button>
      <GenericFlyout
        id="search-dropdown"
        keepMounted
        isOpen={searchOpened}
        close={closeSearchDropdown}
        align={"top"}
        noCloseBtn={true}
        width={52}
        ariaLabel={t("search")}
      >
        <div className={"px-4 py-3 search-dropdown-content"}>
          <Suspense fallback={<Spinner />}>
            <SearchContent displayAsOverlay toggle={toggleSearchDropdown} />
          </Suspense>
        </div>
      </GenericFlyout>
    </>
  );
};

export default SearchDropdown;
